
import MiniMainCard from '../MiniMainCard';

const MainCard = ({ MainTitle, data, isGen4Device }) => {

    const rawRssi = data?.rssi?.value  // Assuming data.rssi contains the RSSI value
    // Number('') and Number(' ') are both 0, so reject blank strings before converting.
    const signalStrength = typeof rawRssi === 'string' && rawRssi.trim() !== '' ? Number(rawRssi) : rawRssi;

    // Gen4 reports a missing reading as the string '--', Gen2/Gen3 report it as undefined.
    // Treat both as "no reading" so the status badge stays hidden.
    const showStatus = typeof signalStrength === 'number' && Number.isFinite(signalStrength);

    let networkStatus = null;
    let bgColour = 'bg-placeholder';

    // Each band is inclusive at its upper (less negative) edge. The chain is ordered, so a
    // branch only needs its own lower bound — the branch above already ruled out anything higher.
    if (isGen4Device) {
        // Gen4 radios report on a wider scale (-30 dBm best, down to -140 dBm at the edge)
        if (signalStrength >= -60) {         // -60 and above
            networkStatus = "Best";
            bgColour = 'bg-alertSuccess'
        } else if (signalStrength >= -90) {  // -90 to -61
            networkStatus = "Good";
            bgColour = 'bg-alertSuccess'
        } else if (signalStrength >= -120) { // -120 to -91
            networkStatus = "Weak";
            bgColour = 'bg-alertWarning'
        } else {                             // below -120
            networkStatus = "Very Weak";
            bgColour = 'bg-alertError'
        }
    } else if (signalStrength >= -50) {      // -50 and above
        networkStatus = "Excellent";
        bgColour = 'bg-alertSuccess'
    } else if (signalStrength >= -60) {      // -60 to -51
        networkStatus = "Good";
        bgColour = 'bg-alertSuccess'
    } else if (signalStrength >= -70) {      // -70 to -61
        networkStatus = "Fair";
        bgColour = 'bg-alertWarning'
    } else if (signalStrength >= -80) {      // -80 to -71
        networkStatus = "Weak";
        bgColour = 'bg-alertError'
    } else {                                 // below -80
        networkStatus = "Very Weak";
        bgColour = 'bg-alertError'
    }

    return (
        <div className=' w-full h-48 md:h-48 md:w-72 2xl:h-56 2xl:w-96 p-4 text-[12px] md:text-[12px] 2xl:text-[14px] border-2 border-dividerLines bg-secondaryBg rounded-md'>
            {MainTitle ? (
                <>
                    <div className=' flex justify-between items-center'>
                        <span className='capitalize font-bold text-[14px] 2xl:text-base'>
                            {MainTitle}
                        </span>
                        {showStatus && networkStatus ?
                            <div className={`text-labels text-center text-[10px] 2xl:text-[12px] font-semibold max-w-fit ${bgColour} px-2 py-0.5 rounded-xl`}>
                                <span>{networkStatus}</span>
                            </div>
                            :
                            <></>
                        }
                    </div>
                </>
            )
                : '--'
            }
            <hr className=" my-2 h-[1px] border-t-0 bg-dividerLines " />
            <MiniMainCard
                miniCardData={data}
            />
        </div >
    )
}

// Skip prop validation by setting propTypes to null
MainCard.propTypes = null;

export default MainCard